var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestedConnectors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 145,
    viewBox: "0 0 432 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 56.5C0 45.4543 8.95431 36.5 20 36.5H412C423.046 36.5 432 45.4543 432 56.5V144.5H0V56.5Z",
    fill: "#FFDD33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M330.265 102.106C331.42 107.388 329.477 112.868 325.254 116.245C321.03 119.621 315.257 120.309 310.358 118.02C310.207 117.949 310.056 117.879 309.885 117.799C309.072 121.415 306.665 124.467 303.339 126.102C300.014 127.737 296.127 127.779 292.767 126.216C292.114 125.912 291.489 125.551 290.899 125.137C290.654 125.852 290.371 126.554 290.051 127.239C286.288 135.297 278.009 140.264 269.127 139.791C260.246 139.318 252.541 133.501 249.654 125.088C245.321 129.365 239.175 131.26 233.186 130.167C227.196 129.075 222.116 125.131 219.572 119.6C219.451 119.316 219.157 119.146 218.851 119.183C216.443 119.361 214.028 118.939 211.823 117.954C196.038 112.32 194.874 103.859 172.841 102.7C150.809 101.54 139.898 90.1055 139.898 90.1055C139.898 90.1055 159.748 99.3619 173 90.489C183.112 83.6965 189.402 84.6095 191.324 85.3852C191.435 85.4231 191.559 85.3976 191.646 85.3186C191.733 85.2396 191.77 85.1196 191.743 85.0052C190.907 82.2531 191.618 79.2641 193.604 77.1832C195.59 75.1024 198.542 74.2523 201.33 74.9585C199.901 71.6984 200.081 67.9567 201.818 64.8495C203.555 61.7423 206.648 59.6287 210.174 59.1392C207.978 52.4171 209.635 45.0323 214.493 39.8931C219.351 34.7539 226.631 32.6839 233.466 34.4983C233.62 34.0335 233.801 33.5783 234.01 33.135C236.979 26.7678 244.546 24.0117 250.914 26.9782C251.226 27.1236 251.538 27.2691 251.842 27.4568C251.881 27.3617 251.924 27.2686 251.972 27.1779C254.963 20.7793 260.865 16.223 267.813 14.9488C274.76 13.6745 281.895 15.8398 286.962 20.7603C294.271 8.95703 309.515 4.89984 321.724 11.5087C333.932 18.1176 338.87 33.0998 332.983 45.6725C339.351 48.6419 342.109 56.2092 339.145 62.5796C338.354 64.2853 337.189 65.7913 335.738 66.9864C344.845 69.0882 350.785 77.8653 349.351 87.1018C347.916 96.3383 339.594 102.9 330.278 102.14L330.265 102.106Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.488 33.9735C232.521 34.224 234.501 34.7977 236.353 35.6727C237.539 36.2253 238.667 36.8956 239.719 37.6735",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M327.22 28.4038C327.31 29.2298 327.332 30.0618 327.286 30.8914",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M320.004 19.1013C323.33 20.2903 325.872 23.0203 326.821 26.4227",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230.968 122.492C230.968 122.492 236.602 125.366 241.088 121.014",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M333.524 44.2908C331.757 48.0931 329.1 51.4134 325.777 53.9699",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M268.172 75.309C271.964 72.8157 277.023 73.5617 279.933 77.0435C282.844 80.5252 282.682 85.6362 279.556 88.9261C278.786 89.7442 277.868 90.4076 276.849 90.8805",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M291.671 119.076C291.74 121.358 291.402 123.634 290.672 125.797",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M273.27 52.0002C277.907 46.714 285.635 45.4439 291.72 48.9677C297.805 52.4915 300.55 59.826 298.274 66.4793C301.504 67.1234 304.144 69.442 305.2 72.5613C306.256 75.6806 305.567 79.1264 303.393 81.5998",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M298.274 66.4796C297.709 68.1123 296.874 69.6389 295.805 70.9962",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M252.876 102.459C251.244 103.932 248.982 104.488 246.853 103.941C244.724 103.394 243.011 101.816 242.291 99.7387C237.407 101.977 231.622 100.479 228.438 96.1522C225.253 91.825 225.543 85.8567 229.132 81.8586C225.339 78.0158 224.118 72.3218 226.002 67.2614C227.887 62.2011 232.535 58.6927 237.918 58.2673",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M227.917 83.4781C229.579 80.7998 232.28 78.9328 235.372 78.3237",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M268.297 30.8543C268.978 29.3371 270.687 28.569 272.274 29.0658C273.862 29.5625 274.827 31.1673 274.523 32.8025C274.45 33.2093 274.298 33.5979 274.076 33.9463",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M275.217 115.69C276.003 117.778 275.101 120.123 273.119 121.146C271.138 122.169 268.704 121.546 267.457 119.696C267.148 119.237 266.926 118.724 266.805 118.183",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M327.075 76.2961C328.711 76.6115 329.852 78.1019 329.73 79.7637C329.607 81.4256 328.26 82.7324 326.595 82.8044C326.183 82.8238 325.771 82.7646 325.382 82.6299",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M209.877 102.311C208.671 102.555 207.43 102.105 206.661 101.144C205.892 100.184 205.724 98.8751 206.225 97.7517C206.726 96.6284 207.813 95.8791 209.041 95.8103",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.307 83.0424L77.4093 133.3C75.5893 132.397 74.2812 130.712 73.8573 128.726L58.4635 55.5417C58.0416 53.5492 58.5605 51.4735 59.8704 49.9141L109.307 83.0424Z",
    fill: "#9E59FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M203.368 106.815L179.734 90.9664L153.931 73.661L185.822 23.4038C187.652 24.3032 188.964 25.9952 189.381 27.9904L204.775 101.174C205.201 103.171 204.681 105.252 203.368 106.815Z",
    fill: "#9E59FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.307 83.0424L77.4093 133.3C75.5893 132.397 74.2812 130.712 73.8573 128.726L58.4635 55.5417C58.0416 53.5492 58.5605 51.4735 59.8704 49.9141L109.307 83.0424Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.368 106.815L179.734 90.9664L153.931 73.661L185.822 23.4038C187.652 24.3032 188.964 25.9952 189.381 27.9904L204.775 101.174C205.201 103.171 204.681 105.252 203.368 106.815Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M203.368 106.814L203.336 106.852C203.229 106.972 203.134 107.085 203.027 107.193C202.909 107.317 202.785 107.435 202.655 107.546C202.535 107.66 202.396 107.767 202.264 107.874C202.138 107.97 202.008 108.058 201.872 108.139C201.777 108.205 201.678 108.266 201.576 108.322C201.472 108.385 201.365 108.442 201.254 108.492C200.745 108.75 200.204 108.938 199.645 109.054L81.7498 133.848C81.2892 133.944 80.8197 133.99 80.3492 133.987C80.1978 133.987 80.0338 133.987 79.8824 133.987H79.7183L79.4218 133.949C79.254 133.927 79.0876 133.896 78.9234 133.854C78.8899 133.858 78.856 133.858 78.8225 133.854L78.5764 133.785L78.3114 133.703C78.1069 133.64 77.9067 133.565 77.7121 133.476L77.466 133.362H77.4219L109.32 83.1052L128.442 95.925C130.555 97.3309 133.146 97.8231 135.627 97.2896C138.108 96.7561 140.268 95.2423 141.616 93.0922L153.95 73.6606L179.753 90.9661L203.368 106.814Z",
    fill: "#9E59FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M166.094 26.0914L181.501 22.8486C182.963 22.5416 184.486 22.7372 185.823 23.4038L173.615 42.6461L142.07 92.3102C140.583 94.6541 138.212 96.2981 135.495 96.8694C132.779 97.4408 129.947 96.891 127.641 95.3448L59.8516 49.9203C60.8053 48.7692 62.1225 47.977 63.5865 47.6744L155.256 28.3879",
    fill: "#FF81AF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M166.094 26.0914L181.501 22.8486C182.963 22.5416 184.486 22.7372 185.823 23.4038L173.615 42.6461L142.07 92.3102C140.583 94.6541 138.212 96.2981 135.495 96.8694C132.779 97.4408 129.947 96.891 127.641 95.3448L59.8516 49.9203C60.8053 48.7692 62.1225 47.977 63.5865 47.6744L155.256 28.3879",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M119.894 62.2168L124.032 69.6487",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M122.979 57.3398L130 69.9578",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M129.767 59.1187L132.082 63.2763",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestedConnectors);
export default __webpack_public_path__ + "static/media/requested-connectors.78fbf1677379ed5c78a51cc1ba3413d9.svg";
export { ForwardRef as ReactComponent };